import React from 'react'
import gridClasses from '../../styles/grid.module.css'
import classes from './Wizard.module.css'
import classNames from 'classnames'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { Switch, Route } from 'react-router'
import Footer from '../../components/Footer/Footer'
import { Redirect } from 'react-router-dom'
import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg'
import { wizardSelectors } from './wizardSlice'
import { useSelector } from 'react-redux'
import { wizardSteps } from './wizardLogic'
import { userSelectors } from '../../redux/userSlice'

const WizardStep = ({ title, active, done }) => {
    return (
        <div
            className={classNames(
                classes.wizardStep,
                (active || done) && classes.wizardStepActive
            )}
        >
            <span className={classes.wizardStepIcon}>
                {done && <CheckIcon className={classes.wizardStepIconSvg} />}
            </span>
            <p className={classes.wizardStepText}>{title}</p>
        </div>
    )
}

const WizardWrapper = ({ match, location }) => {
    const { path } = match
    const { pathname } = location
    const { steps, currentStep: currentStepId, mode } = useSelector(
        wizardSelectors.wizardState
    )
    const userType = useSelector(userSelectors.userType)
    if (!currentStepId || !mode) {
        if (!userType) return <Redirect to="/" />
        else return <Redirect to="/app/dashboard" />
    }
    return (
        <React.Fragment>
            <AuthenticatedHeader />
            <main
                className={classNames(
                    gridClasses.container,
                    classes.pageContent
                )}
            >
                <div className={classes.wizardContainer}>
                    <nav className={classes.wizardHeader}>
                        {steps.map(step => (
                            <WizardStep
                                key={step.id}
                                title={step.title}
                                active={currentStepId === step.id}
                                done={step.done}
                            />
                        ))}
                    </nav>
                    <div className={classes.wizardBody}>
                        <Switch>
                            {/*Remove trailing slash*/}
                            <Redirect
                                from="/:url*(/+)"
                                to={pathname.slice(0, -1)}
                            />
                            {steps.map(step => {
                                const wizardStep = wizardSteps.find(
                                    wizardStep => wizardStep.route === step.id
                                )
                                return (
                                    <Route
                                        key={step.id}
                                        path={`${path}/${wizardStep.route}`}
                                        component={wizardStep.component}
                                    />
                                )
                            })}
                        </Switch>
                    </div>
                </div>
            </main>
            <Footer />
        </React.Fragment>
    )
}

export default WizardWrapper
